// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__8xbJK"};